export const visit = (vm, at) => {
at({ "da": { "sanitizedEmail": { "imageError": "Dette billede er for stort til at kunne vises.", "expandEmailButtonText": "Udvid", "collapseEmailButtonText": "Skjul", "hideEmailRepliesButtonText": "Skjul trimmet indhold", "showEmailRepliesButtonText": "Se trimmet indhold" } } });
};